/**
 * Apex saas-host overlay is static HTML on marketing Hosting — no RSC `index.txt`.
 * Communio product static export is also multi-tenant: one artifact is served from
 * `{slug}.communiosocial.com` and apex, with `NEXT_PUBLIC_SITE_URL` baked to apex.
 * Soft App Router prefetch/navigation can hit apex marketing Hosting (404 on
 * `index.txt`) and strand the user on communiosocial.com. Prefer hard navigations
 * + no prefetch for product builds.
 */
import { SAAS_HOST_UI } from '@/platform/saas/saasHostUi';

export function nextLinkPrefetch(): false | undefined {
  if (SAAS_HOST_UI) return false;
  if (process.env.NEXT_PUBLIC_COMMUNIO_PRODUCT === 'true') return false;
  return undefined;
}

/** True when Communio product Hosting should use full page loads (same-origin `<a>`). */
export function shouldHardNavigateProductApp(): boolean {
  return process.env.NEXT_PUBLIC_COMMUNIO_PRODUCT === 'true';
}
